export const getRatingColor = (rating: number): string => {
    if (rating >= 9) {
      return 'firstLineColor';
    } else if (rating >= 7 && rating < 9) {
      return 'secondLineColor';
    } else {
      return 'thirdLineColor';
    }
  };